<template>
  <a-form ref='form' :model='search' class="m-t-20" :style="{'marginBottom':'10px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" class='mb15' name='keyword'>
          <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.type" style="width: 30%" @change="inputSelect">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="member_name">微信昵称</a-select-option>
              <a-select-option value="member_id">用户ID</a-select-option>
              <a-select-option value="mobile">手机号</a-select-option>
              <a-select-option value="openid">openID</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <!-- <a-form-item label="微信状态" name='is_sub'>
          <a-select v-model:value="search.is_sub" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option value="0">
              未关注
            </a-select-option>
            <a-select-option value="1">
              已关注
            </a-select-option>
            <a-select-option value="2">
              已跑路
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <!-- <a-form-item label="排序" name='sort_type'>
          <a-select v-model:value="search.sort_type" :style="{width:'180px'}">
            <a-select-option value="">默认排序</a-select-option>
            <a-select-option :value="1">
              关注时间升序
            </a-select-option>
            <a-select-option :value="2">
              关注时间降序
            </a-select-option>
          </a-select>
        </a-form-item> -->
        <!-- <a-form-item label="关注时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD'
            @change="changTime" />
        </a-form-item> -->
        <!-- <a-form-item label="所在地区" name='region'>
          <selectCity v-model:value="search.region" placeholder="所在地区" />
        </a-form-item> -->
        <a-form-item label="会员等级" name='level'>
          <a-select v-model:value="search.level" :style="{width:'180px'}">
            <a-select-option value="">全部</a-select-option>
            <a-select-option v-for='item in vipList' :key='item.vip_number' :value="item.vip_number">{{item.vip_name}}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' v-if='!checkout'>选择</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else >{{!record.select ? "选择":"已选择"}}</a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
  <div class="s_flex_center m-t-10" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
    import { getMemberList,getMemberVip} from '@/api/member'
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 5,
    type: '',
    keyword: '',
    is_sub: '',
    sub_start_time: '',
    sub_end_time: '',
    tag_id: '',
    region: '',
    sort_type: '',
    level: ''
  };
  export default {
    name: "selectUser",
    components: {},
    props: {
      user_id: {
        type: Number || String
      },
      selectList:{
        type:Array
      },
      checkout:{
        type:Boolean
      },
      hiddenHead:{
        type:Boolean
      },
      type_id:{
        type:String,
      },
    
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        typeList: [],
        total: 1,
        selectList:[],
        checkout:false,
        vipList:[]
      });
 let columns = [
        {
          title: "用户ID",
          dataIndex: "member_id",
          key: "member_id",
        },
        {
          title: "微信昵称",
          dataIndex: "member_name",
          key: "member_name",
          customRender: ({ record }) => {
            return record.member_name ? record.member_name : '-'
          },
        },
        {
          title: "会员等级",
          dataIndex: "vip_level_name",
          key: "vip_level_name",
        },
        {
          title: "可用积分",
          dataIndex: "point",
          key: "point",
        },
        {
          title: "手机号码",
          dataIndex: "phone",
          key: "phone",
          customRender: ({ record }) => {
            return record.phone ? record.phone : '-'
          },
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        data.value.map(item => item.select = false)
        if(e!=0){
        e.select = !e.select
        }
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        e.select = !e.select
      }
      //多选确认
      const confirm = () =>{  
        state.selectList = []
        for(var i in data.value){
          if(data.value[i].select == true){
            state.selectList.push(data.value[i])
          }
        }
        emit("select",state.selectList);
      }

      const initData = async (values) => {
        state.listLoading = true;
        try {
          var type_id=props.type_id || values.type_id
          let res = await getMemberList({...values,user_id:props.user_id,type_id,
          region:values.region.length?values.region[values.region.length-1]:''}).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.list;
            state.total = res.data.total;
            if(props.checkout){
              state.checkout = props.checkout
            }
            if(props.selectList || props.selectList.length > 0){
              data.value.forEach(i=>{
                if( props.selectList.find(v=>i.member_id == v.member_id)){
                  i.select=true
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
           //获取会员等级
      const getVip = async () => {
        let res = await getMemberVip().then((res) => res.data);
        if (iscode(res)) {
          state.vipList = res.data;
        }
      };
      onMounted(() => {
        initData(search.value)
        getVip()
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm,
      };
    },
  };
</script>